<template>
  <div class="footer-link-wrap">
    <div class="footer-link-content">
      <div class="footer-link-title">
        <h2>友情链接</h2>
      </div>
      <div class="footer-link-list">
        <div class="footer-link-item">
          <div><a target="_blank" href="https://www.samr.gov.cn/">国家市场监督管理总局</a></div>
          <div><a target="_blank" href="https://www.csei.org.cn/">中国特种设备检测研究院</a></div>
        </div>
        <div class="footer-link-item">
          <div><a target="_blank" href="http://cx.cnca.cn/CertECloud/index/index/page">全国认证认可信息公共服务平台</a></div>
          <div><a target="_blank" href="https://www.cnpat.com.cn/">中国专利信息中心</a></div>
        </div>
        <div class="footer-link-item">
          <div><a target="_blank" href="https://www.nim.ac.cn/">中国计量科学研究院</a></div>
          <div><a target="_blank" href="https://www.creditchina.gov.cn/">信用中国</a></div>
        </div>
        <div class="footer-link-item">
          <div><a target="_blank" href="https://www.cnis.ac.cn/pcindex/">中国标准化研究院</a></div>
          <div><a target="_blank" href="http://std.samr.gov.cn/">全国标准信息公共服务平台</a></div>
        </div>
        <div class="footer-link-item">
          <div><a target="_blank" href="https://www.caiq.org.cn/">中国检验检疫科学研究院</a></div>
          <div><a target="_blank" href="http://www.gsxt.gov.cn/index.html">国家企业信用信息公示系统</a></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.footer-link-wrap{
  padding: 0 210px;
  background: #EAEAEA;
  .footer-link-content{
    margin: 0 auto;
    .footer-link-title{
      padding-top: 30px;
      display: flex;
      justify-content: center;
      position: relative;
      &::before{
        content: '';
        position: absolute;
        top:50px;
        left:0px;
        width: 100%;
        height: 2px;
        background: #DDDDDD;
      }
      h2{
        padding: 0 20px;
        background: #EAEAEA;
        margin: 0;
        font-size: 28px;
        font-weight: bold;
        color: #333333;
        z-index: 999;
      }
    }
    .footer-link-list{
      padding: 0 0 30px 0;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .footer-link-item{
        font-size: 16px;
        div{
          position: relative;
          padding-top: 20px;
          &::before{
            content: '';
            display: block;
            position: absolute;
            top: 28px;
            left: -10px;
            width: 5px;
            height: 5px;
            border-radius: 100%;
            background-color: #333333;
          }
        }
        a{
          color: #333333;
          &:hover{
            color: #C00202;
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>